import { useQuery } from '@tanstack/react-query';
import { acquireGraphToken } from '@/auth/msalConfig';

async function fetchProfilePhoto(): Promise<string | null> {
  try {
    const token = await acquireGraphToken();
    const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) return null;

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
}

export function useProfilePhoto() {
  return useQuery({
    queryKey: ['profile-photo'],
    queryFn: fetchProfilePhoto,
    staleTime: 30 * 60_000, // 30 minutes
    retry: false,
    refetchOnWindowFocus: false,
  });
}
